import {Component, Input, OnInit} from '@angular/core';
import {GlobalConstantsComponent} from '../../../shared/global-constants/global-constants.component';
import {finalize, first} from 'rxjs/operators';
import {HubspotService} from '../../../services/hubspot.service';
//import {MixpanelService} from '../../../shared/services/mixpanel.service';
import {ProcessService} from '../../../services/user-services/process.service';
import {Router} from '@angular/router';
import {RedirectionTrackingService} from '../../../services/user-services/redirection-tracking.service';
import {UserService} from '../../../services/user-services/user.service';
import {AlertService} from '../../../services/alert.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DocumentsSharedService} from '../../../services/documents-shared.service';
import {ProcessSharedService} from '../../../services/process-shared.service';
import {TranslateModule} from '@ngx-translate/core';
import {CityInputComponent} from '../../../shared/components/ux/inputs/city-input/city-input.component';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgCircleProgressModule} from 'ng-circle-progress';
import {NgClass, NgIf} from '@angular/common';
import { LocalSettingsService } from 'src/app/services/local-settings.service';
import {tap} from "rxjs";

const PossibleLayout = {
  md: 'main-default' as 'main-default',
  mp: 'main-in_progress' as 'main-in_progress',
  l: 'list' as 'list',
  g: 'grid' as 'grid',
}
type PossibleLayout = (typeof PossibleLayout)[keyof typeof PossibleLayout];
export {PossibleLayout};

@Component({
    selector: 'app-process-box',
    templateUrl: './process-box.component.html',
    styleUrls: ['./process-box.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf, NgCircleProgressModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgxIntlTelInputModule, CityInputComponent, TranslateModule]
})

export class ProcessBoxComponent implements OnInit {

  @Input() public layoutMode: PossibleLayout = 'main-default';
  @Input() public process:any;
  @Input() public isDownloadButton = false;
  @Input() public classes = '';

  public mediaURL:string = GlobalConstantsComponent.mediaURL;
  private userInformations;
  public pdfLoading =false;
  public isBookingSoonEnded;

  //--- MODAL
  public modalForm: UntypedFormGroup;
  public modalTitle = 'DASHBOARD.DONE.PARTNER_MODAL';
  public isModalFormSubmit  = false;
  currentUser;
  currentLanguage: string;
  //---------

  constructor(
    private hubspotService: HubspotService,
  //  private mixpanel: MixpanelService,
    private processService: ProcessService,
    private router: Router,
    private redirectTracker: RedirectionTrackingService,
    private userService: UserService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private documentService: DocumentsSharedService,
    private sharedProcessService: ProcessSharedService,
    private _localSettings: LocalSettingsService,
  ) { }

  ngOnInit(): void {

    this._localSettings.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );


    if ((this.layoutMode !== 'grid' && this.layoutMode !== 'list') && (this.process.state.name !== 'DONE' && this.process.state.name !== 'NOT_STARTED' && this.process.state.name != 'Start process')) {
      this.layoutMode = 'main-in_progress';
    }
    this.userInformations = this.userService.getInfos();
    this.isBookingSoonEnded = localStorage.getItem('bookingEndNotification');
  }


  private redirect(process) : void {
   // this.mixpanel.track('dashboardProcess '+ process.name + ' clicked');
    if(process.key == "AVI"){
      this.processService.getAviUrl().subscribe((data) => {
        const p = {id:69};
        this.callRedirect(p,data.url);
      });
    }
    else{
      if(process.key == "TRANSFERWISE"){
        this.sendHubspotLead(process);
      }
      this.callRedirect(null,process.link);
    }
  }

  public nextStep(process): void {
    if (process.force_url) {
      this.router.navigate([process.force_url]);
      return;
    }

    if (this.isDownloadButton) {
      if (process.key === 'HOUSING-CERTIFICATE') {
        this.downloadHousingCertificate();
      }
      return;
    }

    if (process.link != null) {
      this.redirect(process);
      return;
    }

    const url = this.buildUrl(process);
    if (!url) {
      this.alertService.openSnackBar('Invalid URL for this process', 'snack-error');
      return;
    }

    this.updateProcessState(process.next_state?.process_state || process.state.name, process);
    this.router.navigate([url]);
  }


  private buildUrl(process): string {
    const k = process.key.toLowerCase();
    let slug = this.currentLanguage + '/';
    let url = '';

    if (k !== 'accommodation' && k !== 'housing-certificate') {
      url = 'account/';
      slug = '/';
    }

    const stateUrl = process.state?.url || 'partners';
    const nextStateUrl = process.next_state?.url || stateUrl;

    if (process.next_state) {
      url = slug + url + k + '/' + nextStateUrl;
    } else {
      url = slug + url + k + '/' + stateUrl;
    }

    if (k === 'accommodation') {
      url = slug + 'accommodation/list';
    }

    return url;
  }


  private sendHubspotLead(process):void {
    this.hubspotService.processTracking({process}).pipe(first()).subscribe();
  }

  private callRedirect(partner, url) :void {
    this.redirectTracker.sendRedirectLinkInformations({
      partner: partner,
      toPage: url,
      partnerRef: null,
    }).subscribe();
  }

  public openModal(modal): void {
    this.currentUser = this.userService.getInfos();
    if (this.process.type == 'LF_SERVICE') {
      this.modalTitle = 'DASHBOARD.DONE.LF_SERVICE.TITLE';
      if (this.process.key == 'ACCOMMODATION') {
        this.modalTitle = 'DASHBOARD.DONE.ACCOMMODATION.TITLE'
        this.modalForm = this.fb.group({
          address: [null, Validators.required],
          city: [null, Validators.required],
          postalCode: [null, Validators.required],
        })
      } else {
        if (this.process.key == 'VISA') {
          this.modalTitle = 'DASHBOARD.DONE.VISA.TITLE'
        }
        this.modalForm = this.fb.group({
          accepted: [null, Validators.required],
        })
      }

    } else {
      this.modalForm = this.fb.group({
        partnerName: [null, Validators.required],
      })
    }
    this.modalService.open(modal, {size: 'md',centered: true});
  }

  public sendDatas() {
    if (this.modalForm.valid) {
      if (this.modalForm.controls.address) {
        this.userService.update({
         address: this.modalForm.value.address,
         studentCity: this.modalForm.value.city,
         studentZipCode: this.modalForm.value.postalCode,
         studentCountry: 'FR',
        }).pipe(first()).subscribe();
      } else if (this.modalForm.controls.partnerName) {
        this.processService.sendProcessDatas(this.process.id, {partner: this.modalForm.value.partnerName}).pipe(first()).subscribe();
      } else {
        this.processService.sendProcessDatas(this.process.id, {validated: this.modalForm.value.accepted}).pipe(first()).subscribe();
      }
      this.updateProcessState('DONE', this.process);
    }
  }

  selectCity(event) {
    if (event && event.name) {
      this.modalForm.controls.city.setValue(event.name)
    }
  }

  public updateProcessState(state, processState) {
    processState.loading = true;
    this.sharedProcessService
      .updateProcessState(state, processState)
      .pipe(
        first(),
        tap((data: any) => {
          processState.state.name = state;
          processState.state.id = data.newId || null;
          processState.next_state = data.next_state || null;
          this.processService.updateProcessCompletion(this.userInformations);
        }),
        finalize(() => {
          processState.loading = false;
          this.modalService.dismissAll();
        })
      )
      .subscribe({
        error: (error) => {
          this.alertService.openSnackBar(JSON.stringify(error), 'snack-error');
        }
      });
  }


  private downloadHousingCertificate() {
    this.pdfLoading = true;
    this.documentService.genPdf('CRT_HBG').subscribe(
      (data: Blob) => {
        const file    = new Blob([data], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        const a         = document.createElement('a');
        a.href        = fileURL;
        a.target      = '_blank';
        a.download    = 'certificat_hebergement.pdf';
        document.body.appendChild(a);
        a.click();
        this.pdfLoading = false;
      },
      (error) => {
        this.pdfLoading = false;
      }
    )
  }

  getBackgroundImg(process){
    if(!process.background_img || process.background_img == ''){
      return 'assets/img/process/default-service.png';
    }
    return this.mediaURL + process.background_img;
  }

}
